import { z } from 'zod'

/**
 * How a report's Google Sheet (and, with CLI-942's next step, its CSV) is laid out — one owner for
 * the vocabulary the Delivery tab, the API and the sheet builder share.
 *
 * - `portal`: the admin portal's generic sheet (CLI-940) — Outlet, Article, Author, Link, one row
 *   per item, header by header.
 * - `outletRegion`: the portal's Avoq LA28 sheet — the same columns under National, Local and
 *   International section rows by where the OUTLET is based and whom it serves (never where the
 *   story happened), broadcast rows naming the station as the outlet, "Staff" for an author-less
 *   row, and a link listed once.
 *
 * A `custom` layout — columns and grouping chosen per report — is the step after this one.
 */
export const SHEET_LAYOUT_PRESETS = ['portal', 'outletRegion'] as const
export const sheetLayoutPresetSchema = z.enum(SHEET_LAYOUT_PRESETS)
export type SheetLayoutPreset = z.infer<typeof sheetLayoutPresetSchema>

export const sheetLayoutSchema = z.object({
  preset: sheetLayoutPresetSchema.default('portal'),
})
export type SheetLayout = z.infer<typeof sheetLayoutSchema>

/** What each preset is called where a person picks one. */
export const SHEET_LAYOUT_LABELS: Record<SheetLayoutPreset, string> = {
  portal: 'One row per item',
  outletRegion: 'By outlet region',
}

/** The sections `outletRegion` groups under, in the order they appear. */
export const OUTLET_REGIONS = ['National', 'Local', 'International'] as const
export const outletRegionSchema = z.enum(OUTLET_REGIONS)
export type OutletRegion = z.infer<typeof outletRegionSchema>
